import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faPlay, faPlus, faCode, faPaperclip, faCog, faEdit, faCheckCircle, faAngleRight,
    faChevronLeft, faChevronRight, faArrowLeft, faExclamationCircle, faMinusSquare,
    faAngleDoubleRight, faCaretSquareRight, faLongArrowAltRight, faPause, faMicrochip,
    faUpload, faTimes, faDesktop, faCloud, faCloudUploadAlt, faCircle, faCalendar,
    faStar as filledStar, faDownload, faSortDown, faSortUp, faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';
import { faFileAlt, faTrashAlt, faWindowMaximize, faListAlt, faStar } from '@fortawesome/free-regular-svg-icons';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// noinspection DuplicatedCode
export default function initializeIcons() {
    library.add(faPlay);
    library.add(faPlus);
    library.add(faPaperclip);
    library.add(faFileAlt);
    library.add(faCode);
    library.add(faCog);
    library.add(faEdit);
    library.add(faCheckCircle);
    library.add(faChevronLeft);
    library.add(faChevronRight);
    library.add(faTrashAlt);
    library.add(faAngleRight);
    library.add(faAngleDoubleRight);
    library.add(faArrowLeft);
    library.add(faExclamationCircle);
    library.add(faMinusSquare);
    library.add(faCaretSquareRight);
    library.add(faLongArrowAltRight);
    library.add(faPause);
    library.add(faMicrochip);
    library.add(faWindowMaximize);
    library.add(faUpload);
    library.add(faTimes);
    library.add(faDesktop);
    library.add(faGoogle);
    library.add(faCloud);
    library.add(faCloudUploadAlt);
    library.add(faListAlt);
    library.add(faCircle);
    library.add(faCalendar);
    library.add(faStar);
    library.add(filledStar);
    library.add(faDownload);
    library.add(faSortDown);
    library.add(faSortUp);
    library.add(faExclamationTriangle);
    Vue.component('font-awesome-icon', FontAwesomeIcon);
}
